<template>
    <v-card>
        <v-card-title class="accent white--text subheading">
            {{'Anomaly Detection Scores (Higher indicates error)'|translate}}
            <v-spacer></v-spacer>
            <v-btn color="primary"  dark @click.prevent="openDetail()">
                <v-icon class="mr-2">fa-chart-bar</v-icon>
                {{'Open diagnostics view'|translate}}
            </v-btn>
            <v-btn color="primary" fab small dark @click.prevent="$refs.explanationDialog.openDialog()">
              <v-icon>fa-info</v-icon>
            </v-btn>
            <anomaly-explanation-dialog ref="explanationDialog"></anomaly-explanation-dialog>
        </v-card-title>
        <v-card-text>
            <loading-progress-bar :loading="loading"></loading-progress-bar>
            <v-layout v-if="!loading && noData" row wrap justify-center align-center style="min-height: 200px">
                <v-flex xs12 class="text-xs-center">
                    <v-icon large class="mb-2">fa-exclamation-circle</v-icon>
                    <p class="headline">{{'No anomaly model available for this equipment'|translate}}</p>
                </v-flex>
            </v-layout>
            <vue-plotly disable-responsive v-if="!noData" :data="mydata" :layout="layout" :options="options" @click="handleClick"></vue-plotly>
            <vue-plotly disable-responsive show-export v-if="anomalyData&&!noData" :data="anomalyData"  :layout="barLayout" :options="{}" ref="plotly"/>
        </v-card-text>
    </v-card>
</template>

<script>
  import {getAnomalies} from '@/helper'
  import VuePlotly from '@/components/VuePlotly'
  import LoadingProgressBar from './LoadingProgressBar'
  import AnomalyExplanationDialog from './anomaly/AnomalyExplanationDialog'
  export default {
    name: 'Anomaly',
    components: { AnomalyExplanationDialog, LoadingProgressBar, VuePlotly},
    props:{
      range: Object,
      equipment: String
    },
    data () {
      return {
        loading: true,
        noData: false,
        df: null,
          timeout:null,
          anomalyData:null,
        layout: {
          autosize: true,
          hovermode: 'closest',
          height:1000,
          margin: {
            l: 350
          },
          yaxis: {
            title: this.$options.filters.translate('Issue'),
          },
          xaxis: {
            title: this.$options.filters.translate('timestamp')
          }},
          barLayout:{
            title:this.$options.filters.translate("Top 10 overall anomaly scores"),
              margin: {
                  l: 350
              },
          },
        options: {},
        mydata: []
      }
  },
    watch: {
    range () {
      this.refresh()
    },
    equipment () {
      this.refresh()
    }
    },
    methods: {
        openDetail(){
            let url="/modelsummary?rangeStart="+this.range.start+"&rangeEnd="+this.range.end+"&equipment="+this.equipment
            if (process.env.VUE_APP_SINGLE_WINDOW_MODE){
                window.location.href=url
            } else {
                window.open(url)
            }
        },
        debounce(callback, wait) {
            clearTimeout(this.timeout);
            this.timeout= setTimeout(() => callback(), wait);
        },
        refresh(){
            this.debounce(this.doRefresh,200);
        },
      async doRefresh () {
        this.loading = true
        this.noData = false
        let df = await getAnomalies(
          this.equipment,
          this.$store.state.pointsListStore.pointsList.facility_name,
          {'start': this.range.start, 'end': this.range.end}
        )
          if (!df || !df['timestamp'] || df['timestamp'].length === 0) {
              this.noData = true
              this.loading = false
              return
          }
          let colorscaleValue = [
              [0, this.unifiedIsThemeDark ? "rgb(31, 119, 180)" : '#0000FF'],
              [1, this.unifiedIsThemeDark ? "rgb(214, 39, 40)" : '#FF0000']
          ]
          this.mydata = [{
              x: df['timestamp'],
              y: df['name'],
              z: df['value'],
              type: 'heatmap',
              mode: 'markers',
              colorscale: colorscaleValue,
              zmin:0,
              zmax:1
          }]
          this.loading = false

          let counter={}
          for(let i in df.name){
              if(df.value[i]>=0.5){
                  let [var1,var2]=df.name[i].split('__')
                  if(!counter[var1]){
                      counter[var1]=0
                  }
                  counter[var1]=counter[var1]+df.value[i]
                  if(!counter[var2]){
                      counter[var2]=0
                  }
                  counter[var2]=counter[var2]+df.value[i]
              }
          }
          let sortedFaults = Object.keys(counter).sort(function(a,b){return counter[b]-counter[a]})
          let top10=sortedFaults.slice(0,10);
          let top10Scores=[]
          for(let top of top10){
              top10Scores.push(counter[top])
          }
          this.anomalyData=[{
              type: 'bar',
              x: top10Scores.reverse(),
              y: top10.reverse(),
              orientation: 'h'
          }];

      },
      handleClick(data) {

      let startDate = new Date(data.points[0].x.substring(0,10))
      startDate.setDate(startDate.getDate() - 3)
      let endDate =  new Date(data.points[0].x.substring(0,10))
      endDate.setDate(endDate.getDate()+3)
      let variables = data.points[0].y.split("__")
      let output = {
        path: '/sensors',
        query: {
          variableX: variables[0],
          variableY: variables[1],
          rangeStart: startDate.toISOString().slice(0,10),
          rangeEnd: endDate.toISOString().slice(0,10),
          equipment: this.equipment
        }
      }
      this.$router.push(output)
      }
    },
    mounted () {
      this.refresh()
    }
  }
</script>

<style scoped>

</style>
